import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Volver: al historial si lo hay, y si no, al lugar de arriba en la jerarquía.
 *
 * `navigate(-1)` a secas tiene un agujero que sólo aparece en el teléfono: cuando alguien abre la
 * aplicación desde el acceso directo directo en una pantalla de detalle —o llega por un enlace—,
 * esa es la PRIMERA entrada del historial y no hay nada atrás. El botón de volver queda ahí,
 * visible y muerto: se toca y no pasa nada, que es peor que no tenerlo.
 *
 * React Router numera sus entradas en `history.state.idx`. Con índice cero no hay a dónde
 * retroceder, y entonces se sube un nivel: del ítem a su comida, de la comida al día. Esa subida
 * siempre existe, y es la que convierte un botón muerto en uno que hace lo esperable.
 */
export function useVolver(destinoDeArriba: string): () => void {
  const navigate = useNavigate();

  return useCallback(() => {
    const indice = (window.history.state as { idx?: number } | null)?.idx ?? 0;

    if (indice > 0) {
      navigate(-1);
      return;
    }

    // `replace` para no dejar una entrada que devuelva a la pantalla de la que se acaba de subir.
    navigate(destinoDeArriba, { replace: true });
  }, [navigate, destinoDeArriba]);
}
